import i18n from '@leverege/i18n';
const {
  tIcon
} = i18n.ns('ui-attributes.detail.customText.textEditor.editors.unorderedList');
export default {
  matches: {
    use: 'ParagraphEditor',
    client: 'CustomTextModelEditor'
  },
  id: 'Rich.Text.Editor.UnorderedList',
  layout: {
    sort: 'A.unorderedList'
  },
  handles: () => true,
  appearance: ({
    context
  }) => {
    const {
      editor
    } = context;
    return {
      icon: tIcon('paragraph', 'fa-solid fa-list-ul'),
      checkStyle: 'toggle',
      checked: editor.isActive('bulletList')
    };
  },
  perform: ({
    context,
    action
  }) => {
    const {
      editor
    } = context;
    editor.chain().focus().toggleBulletList().run();
  }
};